// Path: ./src/app/components/EditButtonTopRight/index.tsx
import { IconButton, Tooltip } from "@mui/material";
import { EditButton, TagWrapper } from "./styled";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { PermissionComponentWrapper } from "../PermissionComponentWrapper";

export const EditButtonWrapper = ({
  children,
  onEdit,
  requiredPermission,
  requiredPermissionGroup,
}: {
  children: React.ReactNode;
  onEdit?: () => void;
  requiredPermission: string[];
  requiredPermissionGroup: string[];
}) => {
  return (
    <TagWrapper data-testid="editbuttonwrapper-test-id">
      {children}
      <PermissionComponentWrapper
        requiredPermission={requiredPermission}
        requiredPermissionGroup={requiredPermissionGroup}
        wrapperCss={`
                display:block;
                `}
      >
        <EditButton>
          <Tooltip title="Edit" arrow placement="left">
            <IconButton
              aria-label="edit"
              onClick={onEdit}
              sx={{ color: "#ff813a" }}
            >
              <DriveFileRenameOutlineIcon style={{ fontSize: 21 }} />
            </IconButton>
          </Tooltip>
        </EditButton>
      </PermissionComponentWrapper>
    </TagWrapper>
  );
};
